module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-14.abc52d29.jpg";